import { search, close } from "helper/icons";
import { forwardRef, useImperativeHandle, useState, useEffect } from "react";

const SearchBar = forwardRef((props, ref) => {
  const {
    placeholder,
    onChange,
    width = "w-80",
    extraClass,
    isFaded = false,
    hasBorder = true,
    isShadow = false,
    defaultValue = "",
  } = props || {};
  const [value, setValue] = useState(defaultValue);
  useImperativeHandle(ref, () => ({
    onReset() {
      onTextChange({ target: { value: "" } });
    },
  }));

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const onTextChange = (e) => {
    setValue(e.target.value);
    onChange?.(e);
  };

  const handleIconClick = () => {
    if (value) onTextChange({ target: { value: "" } });
  };

  const icon = value === "" ? search : close;

  return (
    <div className={`relative flex ${extraClass}`}>
      <div
        className={`absolute inset-y-0 right-0 pr-3 flex items-center ${
          value ? "cursor-pointer" : "pointer-events-none"
        }`}
        onClick={handleIconClick}
      >
        <img src={icon} alt="" className="w-5 h-5" />
      </div>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onTextChange}
        className={`${!!isShadow && "shadow-100"} ${
          isFaded ? "bg-white" : "bg-white"
        } text-base text-gray-500 font-normal focus:outline-none focus:shadow-outline ${
          hasBorder && "border border-gray-300 inputFocus"
        } rounded-lg h-11 pl-3.5 pr-3 block ${width}`}
      />
    </div>
  );
});

export default SearchBar;
